/**
 * Supabase oturumunun cihazda saklandığı anahtar — TÜM istemcilerde (TV/web/
 * admin + Dart aynası `mobile-app/lib/data/supabase/backend_config.dart`).
 *
 * ⚠️ BU DEĞER ASLA DEĞİŞTİRİLMEZ. Değişirse güncelleyen HER kullanıcı oturumunu
 * kaybeder: mobil çıkış yapılmış açılır, TV yeni anonim kullanıcı olur.
 *
 * Neden sabit: supabase-js ve supabase_flutter varsayılan anahtarı ADRESTEN
 * türetir (`sb-${hostname.split('.')[0]}-auth-token`). Backend adresi
 * `evyfupeltkoiovebeduo.supabase.co` → `pairo.supabase.pairo.cloud` olunca
 * anahtar da değişiyordu (1.1.17 test paketinde yakalandı, 30 Eki 2026). Değer
 * eski adresin türettiğinin BİREBİR aynısı — böylece mevcut oturumlar korunur
 * ve sonraki her backend taşımasında anahtar artık adresten bağımsızdır.
 */
export const SUPABASE_AUTH_STORAGE_KEY = 'sb-evyfupeltkoiovebeduo-auth-token';
